import { BodyText, Container, HeadingText, Link } from '@paypalcorp/pp-react';
import React from 'react';
import PropTypes from 'prop-types';
import { getComplaintsData } from '../../../jsV2/helpers/twHelper';

const complaintsData = getComplaintsData();

function BrexitComplaintsDataComponent(props) {
  const { openSheetEvent } = props;
  return (
    <Container className="brexit_complaints_data" data-testid="brexit-complaints-data">
      <HeadingText className="brexit_complaints_data__title" data-testid="brexit-complaints-data-title">
        {complaintsData.headingTitle}
      </HeadingText>
      <BodyText className="brexit_complaints_data__text" data-testid="brexit-complaints-data-text-disclaimer">
        {complaintsData.disclaimer}
      </BodyText>
      <BodyText className="brexit_complaints_data__text" data-testid="brexit-complaints-data-text-summary">
        {complaintsData.summary}
        &nbsp;
        <Link onClick={openSheetEvent} data-testid="brexit-complaints-data-text-summary-link">
          {complaintsData.here}
        </Link>
      </BodyText>
    </Container>
  );
}

BrexitComplaintsDataComponent.propTypes = {
  openSheetEvent: PropTypes.func.isRequired,
};

export default BrexitComplaintsDataComponent;
